import { render, staticRenderFns } from "./UserAMALNetHolding.vue?vue&type=template&id=0faa394f&scoped=true"
import script from "./UserAMALNetHolding.vue?vue&type=script&lang=js"
export * from "./UserAMALNetHolding.vue?vue&type=script&lang=js"
import style0 from "./UserAMALNetHolding.vue?vue&type=style&index=0&id=0faa394f&prod&lang=scss"
import style1 from "./UserAMALNetHolding.vue?vue&type=style&index=1&id=0faa394f&prod&lang=scss&scoped=true"
import style2 from "./UserAMALNetHolding.vue?vue&type=style&index=2&id=0faa394f&prod&lang=scss&scoped=true"
import style3 from "./UserAMALNetHolding.vue?vue&type=style&index=3&id=0faa394f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faa394f",
  null
  
)

export default component.exports